import React from "react";
import { Field } from "redux-form";
// import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import { TextField } from "redux-form-material-ui";
import { format } from "date-fns";

export const renderEquipment = ({
  fields,
  meta: { error, submitFailed },
  formInitValues,
}) => {
  const { equipments, agreements } = formInitValues;

  return (
    <Table>
      <colgroup>
        <col style={{ width: "10%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "15%" }} />
      </colgroup>
      <TableHead>
        <TableRow>
          <TableCell>#</TableCell>
          <TableCell>Equipment</TableCell>
          <TableCell>Agreement</TableCell>
          <TableCell>Installation Date</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {fields.map((equipment, index) => (
          <TableRow key={index}>
            <TableCell>
              <Typography component="h6" variant="body2" gutterBottom>
                {`${index + 1}`}
              </Typography>
            </TableCell>
            <TableCell scope="row">
              <Field
                name={`${equipment}.typeId`}
                component={TextField}
                select
                placeholder="Select Equipment"
                margin="none"
                variant="outlined"
                fullWidth
              >
                {equipments ? (
                  equipments.map(equipment => {
                    return (
                      equipment.id !== "*" && (
                        <MenuItem key={equipment.id} value={equipment.id}>
                          {equipment.name}
                        </MenuItem>
                      )
                    );
                  })
                ) : (
                  <MenuItem value="">No Data available</MenuItem>
                )}
              </Field>
            </TableCell>
            <TableCell>
              <Field
                name={`${equipment}.agreement`}
                component={TextField}
                select
                placeholder="Agreement"
                margin="none"
                variant="outlined"
                fullWidth
              >
                {agreements ? (
                  agreements.map(agreement => {
                    return (
                      agreement.id !== "*" && (
                        <MenuItem key={agreement.id} value={agreement.id}>
                          {agreement.name}
                        </MenuItem>
                      )
                    );
                  })
                ) : (
                  <MenuItem value="">No Data available</MenuItem>
                )}
              </Field>
            </TableCell>
            <TableCell>
              <Field
                name={`${equipment}.installationDate`}
                type="date"
                component={TextField}
                margin="none"
                variant="outlined"
                fullWidth
              />
            </TableCell>
            <TableCell>
              <IconButton
                aria-label="Delete"
                onClick={() => fields.remove(index)}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}

        <TableRow>
          <TableCell colSpan={5}>
            <Button
              type="button"
              color="primary"
              variant="outlined"
              size="small"
              onClick={() =>
                fields.push({
                  installationDate: format(new Date(), "yyyy-MM-dd"),
                })
              }
            >
              + Add
            </Button>
          </TableCell>
        </TableRow>

        {submitFailed && error && (
          <TableRow>
            <TableCell colSpan={5}>{error}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default renderEquipment;
